import { render, staticRenderFns } from "./ProjectDetail.vue?vue&type=template&id=3de9664e&scoped=true&"
import script from "./ProjectDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProjectDetail.vue?vue&type=style&index=1&id=3de9664e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de9664e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3de9664e')) {
      api.createRecord('3de9664e', component.options)
    } else {
      api.reload('3de9664e', component.options)
    }
    module.hot.accept("./ProjectDetail.vue?vue&type=template&id=3de9664e&scoped=true&", function () {
      api.rerender('3de9664e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/projects/ProjectDetail.vue"
export default component.exports